import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  IAuditLogMetadata,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui } from "@ryde/theme";

interface IMetadataTooltipContentProps {
  metadata?: IAuditLogMetadata | null;
}

const MetadataTooltipContentStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "metadata-tooltip-content-styled",
})`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px;
  max-width: 400px;

  .metadata-tooltip__row {
    display: flex;
    gap: 8px;
    font-size: 11px;
  }

  .metadata-tooltip__label {
    color: ${greyMui._400};
    font-weight: 500;
    min-width: 80px;
  }

  .metadata-tooltip__value {
    color: white;
    word-break: break-word;
  }
`;

const fields = [
  { key: "ip", label: "IP" },
  { key: "userName", label: "Username" },
  { key: "userFirstName", label: "First Name" },
  { key: "userLastName", label: "Last Name" },
  { key: "userAgent", label: "User Agent" },
];

export const MetadataTooltipContent: FC<IMetadataTooltipContentProps> = ({
  metadata,
}) => {
  const { t } = useTranslation();

  if (!metadata) {
    return null;
  }

  const visibleFields = fields.filter(
    field => metadata[field.key as keyof IAuditLogMetadata],
  );

  const isSyncerPush = metadata.isPushToSyncer === true;

  if (!visibleFields.length && !isSyncerPush) {
    return null;
  }

  return (
    <MetadataTooltipContentStyled>
      {isSyncerPush && (
        <div className="metadata-tooltip__row">
          <div className="metadata-tooltip__label">Syncer</div>
          <div className="metadata-tooltip__value">
            {t("auditLog.pushToSyncerLabel", {
              legacyOldId: metadata.syncerLegacyOldId ?? "",
              recordId: metadata.syncerNewSysRecordId ?? "",
            })}
          </div>
        </div>
      )}
      {visibleFields.map(field => (
        <div key={field.key} className="metadata-tooltip__row">
          <div className="metadata-tooltip__label">{field.label}:</div>
          <div className="metadata-tooltip__value">
            {String(metadata[field.key as keyof IAuditLogMetadata])}
          </div>
        </div>
      ))}
    </MetadataTooltipContentStyled>
  );
};
